<template>
<v-switch class="im-switch ma-0 pa-0" v-model="c_value" inset hide-details color="white" :ripple="false" />
</template>
<script>
export default {
    props: {
        value: Boolean,
    },
    computed: {
        c_value: {
            get: function () {
                return !this.value
            },
            set: function (val) {
                this.$emit('update', !val)
            }
        }
    }
}
</script>
<style lang="stylus">
.im-switch
    &.v-input
        &.v-input--switch--inset
            .v-input--switch__thumb
                height: 15px
                width: 15px
            .v-input--selection-controls__input
                margin-right: 0px
                width: 58px!important
                .v-input--switch__track
                    height: 24px
                    width: inherit
                    background-color: red
                    &.theme--light
                        &:before
                            content: "OFF"
                            color: white
                            position: relative
                            top: 1px
                            left: 20px
                            font-weight: 600
            &.v-input--is-dirty
                .v-input--switch__thumb
                    -webkit-transform: translate(35px)!important
                    transform: translate(35px)!important
                .v-input--switch__track
                    background-color: green
                    &.theme--light
                        &:before
                            content: "ON"
                            color: white
                            position: relative
                            top: 1px
                            left: 10px
                            font-weight: 600
</style>
